import React, { useState, useEffect } from 'react';
import { variables } from "../../utility/variables";
import { Input, Alert } from 'reactstrap';
import { Icons } from "../../utility/icons";
import { useMsal } from '@azure/msal-react';
import * as Msal from '@azure/msal-browser';
import { msalConfig } from '../../utility/authConfig';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

//import jwt_decode from 'jwt-decode';

const loginRequest = {
    scopes: ["User.Read"], // Request the custom API scope
};

const ContactInfo = () => {
    const [users, setUsers] = useState([]);
    const [UserRoles, setUserRoles] = useState([]);
    const [modalTitle, setModalTitle] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [UserName, setUserName] = useState("");
    const [UserEmail, setUserEmail] = useState("");
    const [FullName, setFullName] = useState("");
    const [IsActive, setIsActive] = useState(false);
    const [UserTitle, setUserTitle] = useState("");
    const [UserId, setUserId] = useState(0);
    const [UserIdFilter, setUserIdFilter] = useState("");
    const [UserNameFilter, setUserNameFilter] = useState("");
    const [usersWithoutFilter, setUsersWithoutFilter] = useState([]);
    const [ShowWarning, setShowWarning] = useState(false);
    const [Warning, setWarning] = useState("");
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [filterQuery, setFilterQuery] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState("");
    const [showInviteButton, setShowInviteButton] = useState(true);
    const [RegistrationStatus, setRegistrationStatus] = useState('Yes');
    const [GlobalVendorId, setGlobalVendorId] = useState();
    const [CurrentUserRoles, setCurrentUserRoles] = useState();
    const [CurrentUserEmail, setCurrentUserEmail] = useState();
    const [AccessToken, setAccessToken] = useState([]);

    const [Vendors, setVendors] = useState([]);

    const { instance } = useMsal();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const [vendorName, setvendorName] = useState('');
    const [address, setaddress] = useState('');
    const [eiN_Encrypted, seteiN_Encrypted] = useState('');
    const [globalVendorID, setglobalVendorID] = useState('');
    const [primaryContactEmail, setprimaryContactEmail] = useState('');
    const [primaryContactName, setprimaryContactName] = useState('');
    const [primaryContactPhone, setprimaryContactPhone] = useState('');
    const [secondaryContactEmail, setsecondaryContactEmail] = useState('');
    const [secondaryContactName, setsecondaryContactName] = useState('');
    const [secondaryContactPhone, setsecondaryContactPhone] = useState('');

    const [globalVendors, setglobalVendors] = useState('');

    const [selectedOption, setSelectedOption] = useState(null);

    // Filter roles based on the search term
    const filteredVendors = Vendors.filter((ven) =>
        ven.vendorName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        refreshList();
    }, []);

    function isTokenExpired(token) {
        if (!token) return true; // If no token, consider it expired

        try {
            const payload = JSON.parse(atob(token.split(".")[1])); // Decode payload
            const _date = new Date(payload.exp * 1000);
            return Date.now() >= _date; // Compare expiration time
        } catch (error) {
            return true; // If token is invalid, treat as expired
        }
    }

    const refreshList = async () => {

        fetch(variables.API_URL + 'User', {
            method: "GET",
            mode: "cors",
            credentials: "include", // important to send/set cookies
        })
        .then((response) =>{
            if( response.ok){
                return response.json(); // parse JSON only if status is 2xx
            }
            else if (response.status === 401) {
                // Handle unauthorized
                console.log('ContactInfo: Unauthorized or session expired: Redirect to login');
                alert('Unauthorized or session expired: Redirect to login');
                navigate('/signin');
            }
        })
            .then(data => {
                setUsers(data);
                setUsersWithoutFilter(data);
            });
        fetch(variables.API_URL + 'User/getUserRoles', {
            method: "GET",
            mode: "cors",
            credentials: "include", // important to send/set cookies
        })
            .then(response => response.json())
            .then(data => {
                setUserRoles(data);
            });
        fetch(variables.API_URL + 'User/validateuser', {
            method: "GET",
            mode: "cors",
            credentials: "include", // important to send/set cookies
        })
            .then(response => response.json())
            .then(data => {
                //alert(data);//setUserRoles(data);
                setGlobalVendorId(data[0].GlobalVendorID);
                setCurrentUserRoles(data[0].RoleID);
                setCurrentUserEmail(data[0].UserEmail);
            });
        fetch(variables.API_URL + 'Vendor/GetGlobalVendorList', {
            method: "GET",
            mode: "cors",
            credentials: "include", // important to send/set cookies
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    setglobalVendors(data);
                }
            });

        fetch(variables.API_URL + 'Vendor/GetCurrnetUserContact', {
            method: "GET",
            mode: "cors",
            credentials: "include", // important to send/set cookies
        })
            .then(response => response.json())
            .then(data => {
                if (data && data.length !== 0 && data.length < 2) {
                    //setContactInfo(data);
                    setvendorName(data[0].vendorName);
                    setaddress(data[0].address);
                    seteiN_Encrypted(data[0].eiN_Encrypted);
                    setglobalVendorID(data[0].globalVendorID);
                    setprimaryContactEmail(data[0].primaryContactEmail);
                    setprimaryContactName(data[0].primaryContactName);
                    setprimaryContactPhone(data[0].primaryContactPhone);
                    setsecondaryContactEmail(data[0].secondaryContactEmail);
                    setsecondaryContactName(data[0].secondaryContactName);
                    setsecondaryContactPhone(data[0].secondaryContactPhone);
                }
            });
    };

    const FilterFn = () => {
        const filteredData = usersWithoutFilter.filter(el =>
            el.UserId.toString().toLowerCase().includes(UserIdFilter.toString().trim().toLowerCase()) &&
            el.UserName.toString().toLowerCase().includes(UserNameFilter.toString().trim().toLowerCase())
        );

        setUsers(filteredData);
    };

    const sortResult = (prop, asc) => {
        const sortedData = usersWithoutFilter.sort((a, b) => {
            if (asc) {
                return (a[prop] > b[prop]) ? 1 : (a[prop] < b[prop]) ? -1 : 0;
            } else {
                return (b[prop] > a[prop]) ? 1 : (b[prop] < a[prop]) ? -1 : 0;
            }
        });

        setUsers(sortedData);
    };

    const changeUserIdFilter = (e) => {
        setUserIdFilter(e.target.value);
        FilterFn();
    };

    const changeUserNameFilter = (e) => {
        setUserNameFilter(e.target.value);
        FilterFn();
    };

    // Regex to allow A-Z, a-z, 0-9, ., -, _, and @ for email 
    const regex1 = /^[A-Za-z0-9._\-@]*$/;
    // Regex for the second input: A-Z, a-z, 0-9, ., -, _ for name
    const regex2 = /^[A-Za-z0-9.\-_ ]*$/;
    // Regex for the second input: A-Z, a-z, 0-9, ., -, _, comma for address
    const regex4 = /^[A-Za-z0-9.\-_ ,\n]*$/;
    // for phone number 
    const regex3 = /^\d{3}-\d{3}-\d{4}$/; // /^(\d{3})[-]?(\d{3})[-]?(\d{4})$/;

    const handleChange = (e) => {
        const { name, value } = e.target;
           if (name === "address") { setaddress(value); }
        if (name === "eiN_Encrypted") { seteiN_Encrypted(value); }
        if (name === "primaryContactEmail") { setprimaryContactEmail(value); }
        if (name === "primaryContactName") { setprimaryContactName(value); }
        if (name === "primaryContactPhone") { setprimaryContactPhone(value); }
        if (name === "secondaryContactEmail") { setsecondaryContactEmail(value); }
        if (name === "secondaryContactName") { setsecondaryContactName(value); }
        if (name === "secondaryContactPhone") { setsecondaryContactPhone(value); }
    };

    const handleSelectChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        console.log('Selected Option:', selectedOption);

        var _selectedGV = globalVendors.find(gv => gv.globalVendorID === selectedOption.value);

        if (_selectedGV) {
            //setContactInfo(data);
            setvendorName(_selectedGV.vendorName);
            setaddress(_selectedGV.address ?? '');
            seteiN_Encrypted(_selectedGV.eiN_Encrypted ?? '');
            setglobalVendorID(_selectedGV.globalVendorID ?? '');
            setprimaryContactEmail(_selectedGV.primaryContactEmail ?? '');
            setprimaryContactName(_selectedGV.primaryContactName ?? '');
            setprimaryContactPhone(_selectedGV.primaryContactPhone ?? '');
            setsecondaryContactEmail(_selectedGV.secondaryContactEmail ?? '');
            setsecondaryContactName(_selectedGV.secondaryContactName ?? '');
            setsecondaryContactPhone(_selectedGV.secondaryContactPhone ?? '');
        }
    };

    const loginAndGetToken = async () => {
        const msalInstance = new Msal.PublicClientApplication(msalConfig);
        await msalInstance.initialize();
        try {
            msalInstance.handleRedirectPromise().then((tokenResponse) => {
                if (!tokenResponse) {
                    const accounts = msalInstance.getAllAccounts();
                    if (accounts.length === 0) {
                        msalInstance.loginRedirect();
                    }
                }
            }).catch((err) => {
                console.error(err);
            });

            const tokenResponse = await msalInstance.acquireTokenSilent(loginRequest);
            return tokenResponse.accessToken;
        } catch (error) {
            console.error("Silent token acquisition failed, prompting login:", error);
            const tokenResponse = await msalInstance.acquireTokenPopup(loginRequest);
            return tokenResponse.accessToken;
        }
    };

    const verifyUser = async (UserEmail) => {
        const token = await loginAndGetToken();

        const graphEndpoint = `https://graph.microsoft.com/v1.0/users?$filter=mail eq '${UserEmail}'`;
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${token}`);

        try {
            const response = await fetch(graphEndpoint, { headers });
            if (!response.ok) {
                throw new Error(`Graph API error: ${response.status}`);
            }

            const users = await response.json();
            if (users.value.length > 0) {
                setUserEmail(users.value[0].mail);
                setFullName(users.value[0].displayName);
                setUserTitle(users.value[0].jobTitle);
                setShowWarning(false);
                setWarning("");
                setShowInviteButton(false);
            } else {
                setUserEmail(UserEmail);
                setFullName("");
                setUserTitle("");
                setShowWarning(true);
                setWarning("User does not exist.");
                setShowInviteButton(true);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const handleInvite = async (UserEmail) => {

        let userResponse = true;
        if (UserEmail !== null && CurrentUserEmail !== null && UserEmail.split("@")[1] !== CurrentUserEmail.split("@")[1]) {
            userResponse = window.confirm("User is not under same domain as Admin, do you want to proceed?");
        }

        if (userResponse) {
            const emailExists = users.some(u => u.vendorEmail === UserEmail && UserId !== u.UserId);
            if (emailExists) {
                alert(`The entered email address ${UserEmail} already exists.`);
                return;
            }

            if (UserEmail && UserEmail.toLowerCase().includes('panynj.gov')) {
                alert("User is under PANYNJ domain.");
                return;
            }

            try {
                //const accessToken = await loginAndGetToken();
                //const accessToken = getAccessToken();
                const accesstoken = AccessToken;

                const response = await fetch(variables.API_URL + 'invite/invite', {
                    method: "POST",
                    headers: {
                        // 'Authorization': `Bearer ${accesstoken}`,
                        "Content-Type": "application/json",
                    },
                    credentials: "include", // important to send/set cookies
                    body: JSON.stringify({
                        email: UserEmail,
                        redirectUrl: "/",
                    }),
                });

                if (response.ok) {
                    alert("Invitation sent successfully!");
                } else {
                    const error = await response.json();
                    alert(`Error: ${error.message}`);
                    console.log(`Error: ${error.message}`);
                }
            } catch (err) {
                alert(`Error: ${err.message}`);
                console.log(`Error: ${err.message}`);
            }
        }
    };

    const submitUser = (e) => {
        //if (!isTokenExpired(AccessToken)) {
        {
            // e.preventDefault();
            const isNewUser = UserId === 0;

            if (!regex4.test(address)) {
                alert('Please enter valid address.');
                return;
            }
            if (!primaryContactName || (primaryContactName && !regex2.test(primaryContactName))) {
                alert('Please enter valid primary Name.');
                return;
            }
            if (!primaryContactEmail || (primaryContactEmail && !regex1.test(primaryContactEmail))) {
                alert('Please enter a valid primary Email.');
                return;
            }
            if (primaryContactPhone && !regex3.test(primaryContactPhone)) {
                alert('Please enter a valid primary Phone.');
                return;
            }
            if (secondaryContactName && !regex2.test(secondaryContactName)) {
                alert('Please enter a valid secondary Name.');
                return;
            }
            if (secondaryContactEmail && !regex1.test(secondaryContactEmail)) {
                alert('Please enter a valid secondary Email.');
                return;
            }
            if (secondaryContactPhone && !regex3.test(secondaryContactPhone)) {
                alert('Please enter valid secondary Phone.');
                return;
            }

            const bodyUser = {
                vendorName: vendorName,
                address: address,
                eiN_Encrypted: eiN_Encrypted,
                globalVendorID: globalVendorID,
                primaryContactEmail: primaryContactEmail,
                primaryContactName: primaryContactName,
                primaryContactPhone: primaryContactPhone,
                secondaryContactEmail: secondaryContactEmail,
                secondaryContactName: secondaryContactName,
                secondaryContactPhone: secondaryContactPhone,
            };

            const accesstoken = AccessToken;

            fetch(variables.API_URL + 'vendor', {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    // 'Authorization': `Bearer ${accesstoken}`,
                },
                credentials: "include", // important to send/set cookies
                body: JSON.stringify(bodyUser)
            })
                .then(res => res.json())
                .then((result) => {
                    alert(result);
                    refreshList();
                    closeModal();
                }, (error) => {
                    alert('Failed');
                })
        }
        // else {
        //     navigate('/signin');
        // }
    };

    const deActivateClick = (id) => {
        if (window.confirm('User will be deactivated. Press OK to continue the change.')) {
            const accesstoken = AccessToken;
            fetch(variables.API_URL + 'user/' + id, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    // Authorization: `Bearer ${accesstoken}`,
                },
                credentials: "include", // important to send/set cookies
            })
                .then(res => res.json())
                .then((result) => {
                    alert(result);
                    refreshList();
                }, (error) => {
                    alert('Failed');
                })
        }
    };

    const handleRoleChange = (e) => {
        const options = e.target.options;
        const value = [];
        for (let i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(Number(options[i].value));
            }
        }
        setSelectedRoles(value);
    };

    const handleFilterChange = (event) => {
        setFilterQuery(event.target.value);
    };

    const addNewUser = () => {
        setIsEditing(false);
        setShowModal(true);
        setModalTitle("Add User");
        setSelectedUser("");
        setUserTitle("");
        setUserEmail("");
        setFullName("");
        setUserId(0);
        setIsActive(true);
        setSelectedRoles([]);
        setShowInviteButton(false);
    };

    const openModal = (user) => {
        const _selectedRoles = UserRoles.filter(item => item.userId === user.userId).map(item => item.roleId);

        setIsEditing(true);
        setShowModal(true);
        setModalTitle("Edit User");
        setSelectedUser(user);
        setUserTitle(user.title);
        setUserEmail(user.vendorEmail);
        setSelectedRoles(_selectedRoles);
        setFullName(user.fullName);
        setRegistrationStatus(user.registrationStatus);
        setUserId(user.userId);
        setIsActive(user.isActive);
        setShowInviteButton(false);
    };

    const closeModal = () => {
        setShowModal(false);
        setIsEditing(false);
        setSelectedUser("");
    };


    let _User = users;

    if (CurrentUserRoles === 2) {
        _User = users.filter((user) => {
            return (
                !user.vendorEmail.toLowerCase().includes("panynj.gov") &&
                Number(user.globalVendorID) === Number(GlobalVendorId)
            );
        });
    }

    if (CurrentUserRoles === 2 && CurrentUserEmail.toLowerCase().includes("panynj.gov")) {
        _User = users.filter((user) => {
            return (
                Number(user.globalVendorID) === Number(GlobalVendorId)
            );
        });
    }

    const filteredUsers = _User.filter((user) => {
        return (
            user.fullName.toLowerCase().includes(filterQuery.toLowerCase()) ||
            user.title?.toLowerCase().includes(filterQuery.toLowerCase()) ||
            user.vendorEmail.toLowerCase().includes(filterQuery.toLowerCase())
        );
    });

    var dummyData = {
        RolesOption: []
    };

    if (CurrentUserRoles !== null && Number(CurrentUserRoles) === 3 && CurrentUserEmail && CurrentUserEmail.toLowerCase().includes("panynj.gov") && selectedUser && selectedUser.vendorEmail.toLowerCase().includes("panynj.gov")) {
        dummyData = {
            RolesOption: [
                {
                    roleId: 3,
                    description: 'PA Admin',
                },
                {
                    roleId: 2,
                    description: 'Firm Admin',
                },
                {
                    roleId: 1,
                    description: 'Agreement Manager',
                },
            ]
        }
    }
    else {
        dummyData = {
            RolesOption: [
                {
                    roleId: 2,
                    description: 'Firm Admin',
                },
                {
                    roleId: 1,
                    description: 'Agreement Manager',
                },
            ]
        }
    }
    const options = globalVendors && globalVendors.map(vend => ({
        value: vend.globalVendorID,
        label: vend.vendorName + " ( EIN: " + vend.eiN_Encrypted +")"
    }));

    return (
        <div className='m-4 flex flex-col justify-start w-full rounded'>
            <h5 className="text-xl mb-5 pl-4"></h5>
            {
                CurrentUserRoles !== null && (Number(CurrentUserRoles) === 3 || (Number(CurrentUserRoles) === 2 && globalVendors.length > 1)) &&
                <div className='p-3 w-1/2 bg-slate-100 rounded'>
                    <h6 className='w-1/3'>Select a Vendor:</h6>
                    <Select
                        options={options}
                        value={selectedOption}
                        onChange={handleSelectChange}
                        placeholder="Search and select a vendor"
                    />
                    {/* {selectedOption && <p>You selected: {selectedOption.label}</p>}  */}
                </div>
            }
            <br></br>
            <div className='p-3 w-1/2 bg-slate-100 rounded'>
                <h4 className="text-xl mb-5">Contact Info</h4>
                <div className='flex flex-col gap-2'>
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>Vendor Name</h6>
                        <label className='w-2/3 p-2 border rounded-xl'>
                            {vendorName}
                        </label>
                    </div>
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>EIN</h6>
                        <label className='w-2/3 p-2 border rounded-xl'>
                            {eiN_Encrypted}
                        </label>                        
                    </div>
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>Address <span style={{ color: 'red' }}>*</span></h6>
                        <textarea type="text"
                            rows="2"
                            name="address"
                            value={address}
                            onChange={handleChange}
                            className='w-2/3 p-2 border rounded-xl' placeholder="Address"
                        />
                    </div>
                    {/* <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>EIN</h6>
                        <input type="text"
                            name="eiN_Encrypted"
                            value={eiN_Encrypted}
                            onChange={handleChange}
                            className='w-2/3 p-2 border rounded-xl' placeholder="EIN"
                        />
                    </div> */}
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>Primary Contact Email <span style={{ color: 'red' }}>*</span></h6>
                        <input type="text"
                            name="primaryContactEmail"
                            value={primaryContactEmail}
                            onChange={handleChange}
                            className='w-2/3 p-2 border rounded-xl' placeholder="Primary Contact Email"
                        />
                    </div>
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>Primary Contact Name <span style={{ color: 'red' }}>*</span></h6>
                        <input type="text"
                            name="primaryContactName"
                            value={primaryContactName}
                            onChange={handleChange}
                            className='w-2/3 p-2 border rounded-xl' placeholder="Primary Contact Name"
                        />
                    </div>
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>Primary Contact Phone <span style={{ color: 'red' }}>*</span></h6>
                        <input type="text"
                            name="primaryContactPhone"
                            value={primaryContactPhone}
                            onChange={handleChange}
                            className='w-2/3 p-2 border rounded-xl' placeholder="xxx-xxx-xxxx"
                        />
                    </div>
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>Secondary Contact Email</h6>
                        <input type="text"
                            name="secondaryContactEmail"
                            value={secondaryContactEmail}
                            onChange={handleChange}
                            className='w-2/3 p-2 border rounded-xl' placeholder="Secondary Contact Email "
                        />
                    </div>
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>Secondary Contact Name</h6>
                        <input type="text"
                            name="secondaryContactName"
                            value={secondaryContactName}
                            onChange={handleChange}
                            className='w-2/3 p-2 border rounded-xl' placeholder="Secondary Contact Name"
                        />
                    </div>
                    <div className='flex flex-row w-full align-middle'>
                        <h6 className='w-1/3'>Secondary Contact Phone</h6>
                        <input type="text"
                            name="secondaryContactPhone"
                            value={secondaryContactPhone}
                            onChange={handleChange}
                            className='w-2/3 p-2 border rounded-xl' placeholder="xxx-xxx-xxxx"
                        />
                    </div>
                    <div className='flex-end flex-row w-full align-end'>
                        <button type="button"
                            className="p-2 bg-blue-500 text-white p-2 rounded float-end"
                            onClick={submitUser}>
                            Save
                        </button>
                    </div>
                </div>
            </div>

            {
                showModal && ((selectedUser && modalTitle === "Edit User") || modalTitle === "Add User") && (
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10">
                        <div className="bg-white p-6 rounded shadow-lg max-w-md w-full">
                            <h2 className="text-xl font-semibold mb-4">{modalTitle}</h2>
                            <form>
                                {
                                    ShowWarning ?
                                        <div className="warning">
                                            <Alert key='warning' variant='warning'>
                                                {Warning}
                                            </Alert>
                                        </div>
                                        : null
                                }
                                <div className="mb-4">
                                    <label className="block">Email</label>
                                    <input
                                        type="email"
                                        name="UserEmail"
                                        value={UserEmail.toLowerCase()}
                                        onChange={handleChange}
                                        className="p-2 border border-gray-300 w-full"
                                        disabled={modalTitle === "Edit User"}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block">Full Name</label>
                                    <input
                                        type="text"
                                        name="FullName"
                                        value={FullName}
                                        onChange={handleChange}
                                        className="p-2 border border-gray-300 w-full"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block">Title</label>
                                    <input
                                        type="text"
                                        name="UserTitle"
                                        value={UserTitle}
                                        onChange={handleChange}
                                        className="p-2 border border-gray-300 w-full"
                                    />
                                </div>
                                <div className="input-group mb-4">
                                    <span className="input-group-text">Active</span>
                                    <Input
                                        type="select"
                                        className="form-select p-2 border border-gray-300 w-full"
                                        onChange={handleChange}
                                        name="IsActive"
                                        id="IsActive"
                                        value={IsActive}>
                                        <option value="false">No</option>
                                        <option value="true">Yes</option>
                                    </Input>
                                </div>
                                <div className="input-group mb-4">
                                    <span className="input-group-text">Roles</span>
                                    <select
                                        className="form-select p-2 border border-gray-300 w-full"
                                        title="Roles"
                                        multiple
                                        value={selectedRoles}
                                        onChange={handleRoleChange}>
                                        {dummyData.RolesOption.map((ro, index) =>
                                            (<option key={index} value={ro.roleId}>{ro.description}</option>)
                                        )}
                                    </select>
                                </div>
                                <div className="input-group mb-3">
                                    * Press CTRL on the keyboard to select multiple roles.
                                </div>
                                <div className="flex justify-between">
                                    <button type="button" onClick={() => closeModal()} className="bg-gray-300 p-2 rounded">Cancel</button>
                                    <button type="button" onClick={() => submitUser()} className="bg-blue-500 text-white p-2 rounded">
                                        Save Changes
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
        </div>
    );
};

export default ContactInfo;